import React from 'react';
import './FilterSectionItem.scss';

const FilterSectionItem: React.FC = props => {
  return <li className="FilterSectionItem">{props.children}</li>;
};

export default FilterSectionItem;
